module.exports = __webpack_public_path__ + "img/station.fa5a3987.png";